module.exports = __webpack_public_path__ + "media/images/temp/ribbon-8-128dc2f8702a01a480a921a1caf4b861.png";